import styled from 'styled-components/macro';

export const FiasSearchMockWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: start;
  padding-top: 8px;

  .custom-tooltip {
    transform: translateX(-115px);
    z-index: 1000;

    .react-tooltip-arrow {
      transform: translateX(115px) rotate(45deg);
    }
  }
`;

export const ToggleBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TooltipAnchor = styled.div`
  display: flex;
  align-items: center;
`;
